import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as uploadsApi from '@/modules/bd-unificada/api/uploadsApi'
import { contactosKeys } from '@/modules/bd-unificada/hooks/useContactos'

export const uploadsKeys = {
  all: ['bd-unificada', 'uploads'] as const,
  job: (jobId: string) => [...uploadsKeys.all, 'job', jobId] as const,
}

export function useSubirArchivo() {
  return useMutation({
    mutationFn: ({ archivo, fuenteId }: { archivo: File; fuenteId: string }) =>
      uploadsApi.subirArchivo(archivo, fuenteId),
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al subir el archivo')
    },
  })
}

/**
 * Hace polling del estado del job hasta que llega a `done` o `error`.
 * Pasar `jobId` vacío/null para desactivar el polling.
 */
export function useJobStatus(jobId: string | null) {
  const queryClient = useQueryClient()
  return useQuery({
    queryKey: uploadsKeys.job(jobId || ''),
    queryFn: async () => {
      const job = await uploadsApi.getJob(jobId as string)
      if (job.estado === 'done') {
        // La carga pudo haber cambiado contactos y estadísticas.
        queryClient.invalidateQueries({ queryKey: contactosKeys.all })
      }
      return job
    },
    enabled: !!jobId,
    refetchInterval: (query) => {
      const estado = query.state.data?.estado
      return estado === 'done' || estado === 'error' ? false : 2000
    },
  })
}
